import { render } from "./KalkulatorPage.vue?vue&type=template&id=54a0970f&scoped=true"
import script from "./KalkulatorPage.vue?vue&type=script&lang=js"
export * from "./KalkulatorPage.vue?vue&type=script&lang=js"

import "./KalkulatorPage.vue?vue&type=style&index=0&id=54a0970f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a0970f"]])

export default __exports__